import { Pipe, PipeTransform } from '@angular/core';

import { Row } from '@components/spa-table/spa-table.component';

@Pipe({
  name: 'arrayToRow',
})
export class ArrayToRowPipe implements PipeTransform {
  transform<T>(items: (T | null | undefined)[] | null | undefined): Row<T>[] {
    if (!items?.length) {
      return [];
    }

    // Keep only non-nullish items (so 0, '', false are retained)
    return items.filter((item): item is T => item != null).map((item) => ({ element: item }));
  }
}
